

export const PulseLogo = ({ className = "h-8 w-auto" }: { className?: string }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Abstract Sonar Rings */}
    <circle cx="50" cy="50" r="45" stroke="url(#gradient)" strokeWidth="8" strokeOpacity="0.2" />
    <circle cx="50" cy="50" r="32" stroke="url(#gradient)" strokeWidth="8" strokeOpacity="0.5" />
    <circle cx="50" cy="50" r="19" stroke="url(#gradient)" strokeWidth="8" />
    
    {/* Radar Sweep / Pulse Segment */}
    <path 
      d="M50 50 L85 15 A 50 50 0 0 1 95 50" 
      fill="url(#sweep)" 
      opacity="0.4"
    />
    
    {/* Center Core */}
    <circle cx="50" cy="50" r="8" fill="var(--theme-cta)" />

    {/* Definitions */}
    <defs>
      <linearGradient id="gradient" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--theme-cta)" />
        <stop offset="1" stopColor="var(--theme-cta-hover)" />
      </linearGradient>
      <linearGradient id="sweep" x1="50" y1="50" x2="90" y2="20" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--theme-cta)" stopOpacity="0.8" />
        <stop offset="1" stopColor="var(--theme-cta)" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
